import ENV, { ENV_DEV, ENV_TEST, ENV_PROD } from '@/constants/env'


export const API_BASE_URL = (() => {
  if (ENV === ENV_PROD) {
    return 'https://www.dana.id/'
  } else if (ENV === ENV_TEST) {
    return 'https://webdev.dana.id/'
  } else if (ENV === ENV_DEV) {
    return 'http://localhost:9200/data/dana-academy/'
  }
})()

export async function api(resource, data={}, method='GET', version='v1') {
  let url
  if (ENV === ENV_DEV) {
    url = API_BASE_URL + `api.${version}.learning-platform.${resource}`
  } else {
    url = API_BASE_URL + `api/${version}/learning-platform/${resource}`
  }
  const params = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
    },
  }

  if (method === 'GET') {
    const queries = new URLSearchParams(data)
    url += '?' + queries.toString()
  } else if (method === 'POST') {
    params.body = JSON.stringify(data)
  }

  const response = await fetch(url, params)
  if (response.ok) {
    const result = await response.json()
    return result
  } else {
    throw new Error()
  }
}

export function fetchOnlineConfig(type) {
  const url = `https://a.m.dana.id/resource/json/dana-academy/${type}.json?`
  return fetch(url).then(response => response.json())
}
